module.exports = __webpack_public_path__ + "static/media/mooon-cafe.78b0a516.jpg";